/**
 * What a chosen seat costs ON A SEASON PASS, in the browser.
 *
 * A reserved seat carries TWO prices and they are not the same kind of thing:
 *
 *   - `EventSeatStatus.price` — what that seat costs for ONE GAME. Baked per
 *     event when the event is published, and preferred everywhere in the
 *     normal event flow because it is what the cart charges.
 *   - the season tier bound to the seat's category — what the SEASON PASS
 *     costs. This is what the server charges for a pass
 *     (src/lib/seasons/price-season-items.ts).
 *
 * The seat picker is shared between both flows and preferred the baked price.
 * In season mode that is a category error: it advertised a $200 season pass at
 * $11, the price of one game at that seat, and the buyer was then charged the
 * $200 the server priced. Best Available made it certain — the season seat
 * search is answered by the EVENT endpoint (a season id resolves to its first
 * event), so every returned seat carries a single game's price.
 *
 * So: on a season pass the tier price is the ONLY price. There is deliberately
 * no fallback to the per-game figure — a seat whose category resolves to no
 * tier has no season price, and the cart line it would write carries no
 * `seasonTicketTypeId`, which the server refuses outright. Showing zero is
 * visibly wrong; showing one game's price is invisibly wrong.
 */

/**
 * The season price of a seat, from the tier bound to its category. The seat's
 * own per-game price is not a parameter on purpose: there is no input it could
 * be given here that would make it the right answer.
 */
export function seasonPassSeatPrice(tierPrice: number | null | undefined): number {
  const tier = Number(tierPrice)
  return Number.isFinite(tier) && tier > 0 ? tier : 0
}
